import Phaser from "phaser";
import { CodexMonsterSlot } from "@phaser/ui/codex/CodexMonsterSlot";

type CodexSectionMonster = {
  id: string;
  key: string;
  discovered: boolean;
};

interface CodexSectionOptions {
  width: number;
  title: string;
  monsters: CodexSectionMonster[];
  columns?: number;
}

export class CodexSection extends Phaser.GameObjects.Container {
  public contentHeight = 0;

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    options: CodexSectionOptions,
  ) {
    super(scene, x, y);
    scene.add.existing(this);

    const sidePadding = 68;
    const columns = options.columns ?? 4;

    const itemWidth = 128;
    const itemHeight = 128;
    const colGap = 40;
    const rowGap = 40;

    // 스테이지 제목
    const title = scene.add.text(sidePadding, 4, options.title, {
      fontFamily: "Black Han Sans",
      fontSize: "40px",
      color: "#FFFFFF",
    });

    // 구분선
    const line = scene.add.rectangle(
      options.width / 2,
      52,
      options.width - sidePadding * 2,
      4,
      0xffffff,
    );
    line.setOrigin(0.5, 0.5);

    this.add([title, line]);

    const gridStartY = 80; // 몬스터 그리드 시작 위치

    // 몬스터 슬롯 생성 및 배치
    options.monsters.forEach((monster, index) => {
      const col = index % columns;
      const row = Math.floor(index / columns);

      const slotX = sidePadding + col * (itemWidth + colGap) + itemWidth / 2;
      const slotY = gridStartY + row * (itemHeight + rowGap) + itemHeight / 2;

      const slot = new CodexMonsterSlot(scene, slotX, slotY, {
        monsterId: monster.id,
        textureKey: monster.key,
        discovered: monster.discovered,
        width: itemWidth,
        height: itemHeight,
      });

      this.add(slot);
    });

    const rows = Math.ceil(options.monsters.length / columns);

    if (rows === 0) {
      this.contentHeight = gridStartY;
      return;
    }

    this.contentHeight = gridStartY + rows * itemHeight + (rows - 1) * rowGap; // 콘텐츠 전체 높이 계산
  }
}
